import React, { useRef, useState , useEffect,useMemo} from 'react';
import invoiceEvaluationService from './sale-invoice-evaluation.service';
import {
  StructuredGenerate,
  DynamicDropDownInput,
  DynamicNumericInput,
  DynamicDateInput,
  DynamicTextInput,
  DynamicCheckBoxInput,
  DynamicHiddenInput,
  DynamicButtonInput
} from '../software-dynamic-version-5/mainSection-multiple-inputs-v-5';
import './sale-invoice-evaluation.scss'
import SecurityService from '../security/security.service';
 let ButtonInput = (props)=>{
    return (<div id={'SaleInvoiceEvaluation'} className='row'>
          <div className='col-sm-10'></div>
           <div className='col-sm-1'> <button id="btnSave"  className={` e-control e-btn e-primary `} data-ripple="true" onClick={(e)=>{e.preventDefault(); props.onSave()}}>Save</button></div>
            <div className='col-sm-1'><button id="btnSave"  className={`e-control e-btn e-white `} data-ripple="true" onClick={(e)=>{e.preventDefault(); props.onClose()}}>Close</button></div>
          </div>);
  }
const InvoiceEvaluationAdd = (props) => {
  let { DynamicDropDownInput: DropdownComponent, DynamicNumericInput: NumberComponent, DynamicDateInput: DateComponent , DynamicTextInput: TextComponent ,DynamicCheckBoxInput:CheckBoxComponent , DynamicHiddenInput : HiddenComponent , DynamicButtonInput:ButtonComponent} = { DynamicDropDownInput, DynamicNumericInput, DynamicDateInput ,DynamicTextInput , DynamicCheckBoxInput,DynamicHiddenInput,DynamicButtonInput};

 const updateMainSecionsValue = (valueObj) => {
    setInputProps((prevValues) => {
      const updatedValues = { ...prevValues };
  
      Object.keys(valueObj).forEach((key) => {
        if (updatedValues[key]) {
          updatedValues[key] = {
            ...updatedValues[key],
            ...valueObj[key], // Spread the inner object to update its properties
          };
        }
      });
  
      return updatedValues;
    });
  };
  const [inputProps, setInputProps] = useState({
  
    isAdd:{name: 'isAdd', caption: 'isAdd',  value: true },
    // TransactionDate:{name: 'TransactionDate',   value: props.TransactionDate || ''},
    InvoiceNo:{
      name:'InvoiceNo',
      caption: 'Invoice No',
      value: props.InvoiceNo || '',enabled:false},
      
    InvoiceEvaluationID:{name: 'InvoiceEvaluationID', caption: 'InvoiceEvaluationID',  value: props.InvoiceEvaluationID || 0 },
    MainInvoiceID:{name: 'MainInvoiceID', caption: 'MainInvoiceID',  value: props.MainInvoiceID || 0 },

    ExchangeRate:{name: 'ExchangeRate', caption: 'Exchange Rate',  value: props.ExchangeRate || 0 , decimal:1},

    HawalaCommissionPercent:{name: 'HawalaCommissionPercent', caption: 'Hawala Commission %',  value: props.HawalaCommissionPercent || 0.00 , decimal:2},
    
    CurrencyName:{
      name:{id:'CurrencyID',value:'CurrencyName'},
      caption: 'Select Currency',
      value: {id:  2 ,value: ''},
      dataSource: {type:'Route',route:'Currency'},
      enabled:false

      //   addNew:{Route:'sldf',Security:'df'},
      // isControlBlur:false
    },
    CurrencyNameHawala:{
      name:{id:'CurrencyIDHawala',value:'CurrencyNameHawala'},
      caption: 'Select Currency Hawala',
      value: {id: '1' ,value: ''},
      dataSource: {type:'Route',route:'Currency'},
      enabled:false
       //   addNew:{Route:'sldf',Security:'df'},
      // isControlBlur:false
    },
    
    
    
    
    
    
    
    
    
    
    AccountTitleHawalaDr:{name: 'AccountTitleHawalaDr', caption: 'Account Title Hawala Dr',  value: props.AccountTitleHawalaDr || '',enabled:false},
    AccountIDHawalaDr:{name: 'AccountIDHawalaDr', caption: 'Account ID Hawala Dr',  value: props.AccountIDHawalaDr || '' },
    
    AccountTitleHawalaCr:{name: 'AccountTitleHawalaCr', caption: 'Account Title Hawala Cr',  value: props.AccountTitleHawalaCr || '',enabled:false},
    AccountIDHawalaCr:{name: 'AccountIDHawalaCr', caption: 'Account ID Hawala Cr',  value: props.AccountIDHawalaCr || '' },
    


  //   AccountTitleHawalaDr:{
  //     name:{id:'AccountIDHawalaDr',value:'AccountTitleHawalaDr'},
  //     caption: 'Select Account Hawala Dr',
  //     dataSource: {type:'Route',route:'ChartOfAccount'},
  //     value: {id: props.AccountIDHawalaDr || '' ,value:props.AccountTitleHawalaDr || ''},
  //     enabled:false,
  //     floatLabelType:'Always'
  //  //   addNew:{Route:'sldf',Security:'df'},
  //     // isControlBlur:false
  //   },
    
  //   AccountTitleHawalaCr:{
  //     name:{id:'AccountIDHawalaCr',value:'AccountTitleHawalaCr'},
  //     caption: 'Select Account Hawala Cr',
  //     value: {id: props.AccountIDHawalaCr || '' ,value:props.AccountTitleHawalaCr || ''},
  //     dataSource: {type:'Route',route:'ChartOfAccount'},
  //     enabled:false,
  //     floatLabelType:'Always'
  //     //   addNew:{Route:'sldf',Security:'df'},
  //     // isControlBlur:false
  //   }
    
    });
// EXTRA CODE START
const getDefaultValueOfAccountTitleHawalaDr = async ()=>{
    try {
      const response = await invoiceEvaluationService.getDefaultAccountTitleHawalaDr();
      if (response.data && response.data.recordset) {
        console.log(response.data.recordset[0].id);
        document.getElementById('AccountTitleHawalaDr').value = response.data.recordset[0]?.value

        setInputProps((prevValues) => ({
          ...prevValues,
          ['AccountTitleHawalaDr']: {...prevValues['AccountTitleHawalaDr'] ,value:response.data.recordset[0].value },
          ['AccountIDHawalaDr']: {...prevValues['AccountIDHawalaDr'] ,value :response.data.recordset[0].id  }
    
        }));
      }
        else {
        console.error("Invalid response structure:", response);
      }
     } catch (error) {
      }
  }
const getDefaultValueOfAccountTitleHawalaCr = async ()=>{
    try {
      const response = await invoiceEvaluationService.getDefaultAccountTitleHawalaCr();
      if (response.data && response.data.recordset) {
        console.log(response)
        document.getElementById('AccountTitleHawalaCr').value = response.data.recordset[0]?.value
        setInputProps((prevValues) => ({
          ...prevValues,
          // ['AccountTitleHawalaCr']: {...prevValues['AccountTitleHawalaCr'] ,value :{id:response.data.recordset[0]?.id, value:response.data.recordset[0]?.value} }
          ['AccountTitleHawalaCr']: {...prevValues['AccountTitleHawalaCr'] ,value:response.data.recordset[0].value },
          ['AccountIDHawalaCr']: {...prevValues['AccountIDHawalaCr'] ,value :response.data.recordset[0].id  }
    
        }));
      }
        else {
        console.error("Invalid response structure:", response);
      }
     } catch (error) {
      }
  }


// EXTRA CODE END

const checkIsEditPopup = async () => {
  try {
    // const mainInvoiceID = 45734;
    const mainInvoiceID = props?.MainInvoiceID || inputProps.MainInvoiceID.value;
    if (mainInvoiceID && mainInvoiceID !== 0) {
      const response = await invoiceEvaluationService.getInvoiceEvaluation();

      if (response.data && response.data.recordset && response.data.recordset.length > 0) {

        const record = response.data.recordset.filter((row)=>row.MainInvoiceID == mainInvoiceID);
          console.log(record)
        if(record.length > 0){
        updateMainSecionsValue({
          InvoiceEvaluationID: { value: record[0].InvoiceEvaluationID || 0 },
          ExchangeRate: { value: record[0].ExchangeRate || 0 },
          HawalaCommissionPercent: { value: record[0].HawalaCommissionPercent || 0 },
          AccountTitleHawalaDr: { value: record[0].AccountTitleHawalaDr || '' },
          AccountIDHawalaDr: { value: record[0].AccountIDHawalaDr || '' },
          AccountTitleHawalaCr: { value: record[0].AccountTitleHawalaCr || '' },
          AccountIDHawalaCr: { value: record[0].AccountIDHawalaCr || '' },
          isAdd:{value:false},
          CurrencyNameHawala:{value:{
                value:record[0].CurrencyNameHawala ,
                id:record[0].CurrencyIDHawala 
          }},
          CurrencyName:{value:{
                value:record[0].CurrencyName,
                id:record[0].CurrencyID 
          }}
        });
        setTimeout(() => {
          
          if(document.getElementById('ExchangeRate_display')){
          document.getElementById('ExchangeRate_display').focus()
          document.getElementById('ExchangeRate_display').select()
        }
      }, 1000);
        
      }else{
         // No records found, call default value functions
        getDefaultValueOfAccountTitleHawalaDr();
        getDefaultValueOfAccountTitleHawalaCr();
         if(document.getElementById('ExchangeRate_display')){
          document.getElementById('ExchangeRate_display').focus()
          document.getElementById('ExchangeRate_display').select()
        }
      }
      } else {
        // No records found, call default value functions
        getDefaultValueOfAccountTitleHawalaDr();
        getDefaultValueOfAccountTitleHawalaCr();
         if(document.getElementById('ExchangeRate_display')){
          document.getElementById('ExchangeRate_display').focus()
          document.getElementById('ExchangeRate_display').select()
        }
      }
    } else {
      // No MainInvoiceID, call default value functions
      getDefaultValueOfAccountTitleHawalaDr();
      getDefaultValueOfAccountTitleHawalaCr();
       if(document.getElementById('ExchangeRate_display')){
          document.getElementById('ExchangeRate_display').focus()
          document.getElementById('ExchangeRate_display').select()
        }
    }
  } catch (error) {
    console.error('Error loading invoice evaluation data:', error);
    // On error, fallback to default values
    getDefaultValueOfAccountTitleHawalaDr();
    getDefaultValueOfAccountTitleHawalaCr();
     if(document.getElementById('ExchangeRate_display')){
          document.getElementById('ExchangeRate_display').focus()
          document.getElementById('ExchangeRate_display').select()
        }
  }
};

const handleInputCreated = async (e, name) => {
  if(name == 'AccountTitleHawalaDr'){
    document.getElementById('ExchangeRate_display').blur()
    checkIsEditPopup()
    //  getDefaultValueOfAccountTitleHawalaDr()
  }else if(name ==  'AccountTitleHawalaCr'){
    //  getDefaultValueOfAccountTitleHawalaCr()
  }
  
  console.log(e);
    console.log(`Input ${name} changed to ${e}`);
  };
const handleInputFocus = async (e, name) => {
  
    console.log(e);
    console.log(`Input ${name} focus to ${e}`);
  };
const handleInputChange = async (value, name) => {
  
    console.log(value);
    console.log(`Input ${name} focus to ${value}`);
  };
const handleInputBlur = async  (value, name) => {
  
    console.log(value);
    console.log(`Input ${name} focus to ${value}`);
  };
 

let onClose = ()=>{
    console.log('onclose button clicked')
    props.onClose()
}
let onSave = async () => {
    console.log('onSave button clicked');
    try {
        const data = {
            MainInvoiceID:props?.MainInvoiceID  || inputProps?.MainInvoiceID.value,
            ExchangeRate: inputProps?.ExchangeRate.value,
            HawalaCommissionPercent: inputProps.HawalaCommissionPercent.value,
            CurrencyID: inputProps.CurrencyName.value.id,
            CurrencyIDHawala: inputProps.CurrencyNameHawala.value.id,
            AccountIDHawalaDr: inputProps.AccountIDHawalaDr.value,
            AccountIDHawalaCr: inputProps.AccountIDHawalaCr.value,
            InvoiceEvaluationID: inputProps.InvoiceEvaluationID.value
        };
        
        let response;
        if (inputProps.isAdd.value == true) {
            response = await invoiceEvaluationService.insert({...data, CreatedByUserID:SecurityService.getLoggedInUserId()});
            console.log('Insert response:', response);
        } else {
            response = await invoiceEvaluationService.update({...data, UpdatedByUserID:SecurityService.getLoggedInUserId()});
            console.log('Update response:', response);
        }
        
        if (response && response.status === 200) {
            console.log('Save operation successful');
            props.onClose()
            // You can add success notification here
        }
    } catch (error) {
      alert('Request Failed Please Try Again ')
        console.error('Error saving invoice evaluation:', error);
        // You can add error notification here
    }
}
 
  let inputsList = [
    {
      Input: HiddenComponent,
      Props: {
        ...inputProps.InvoiceEvaluationID, 
        // onChange: handleInputChange,
        // onBlur: handleInputBlur,
        setInputProps },ColumnSize:0
      },
    {
      Input: HiddenComponent,
      Props: {
        ...inputProps.MainInvoiceID, 
        // onChange: handleInputChange,
        // onBlur: handleInputBlur,
        setInputProps },ColumnSize:0
      },
    {
      Input: TextComponent,
      Props: {
        ...inputProps.InvoiceNo, 
        // onChange: handleInputChange,
        // onBlur: handleInputBlur,
        setInputProps },
      },
    {
      Input: DropdownComponent,
      Props: {
        ...inputProps.CurrencyName, 
        // onChange: handleInputChange,
        // onBlur: handleInputBlur,
        setInputProps },
      },
    // {
    //   Input: DynamicDateInput,
    //   Props: {
    //     ...inputProps.TransactionDate, 
    //     onCreated:handleInputCreated,  
    //     onFocus: handleInputFocus, 
    //     onChange: handleInputChange,
    //     onBlur: handleInputBlur,
    //     setInputProps },
    //   ColumnSize: 4
    // },
   
    {
      Input: NumberComponent,
      Props: {
        ...inputProps.ExchangeRate, 
        // onCreated:handleInputCreated,
        // onBlur: handleInputBlur,
        setInputProps },
      },
    {
      Input: NumberComponent,
      Props: {
        ...inputProps.HawalaCommissionPercent, 
        // onBlur: handleInputBlur,
        setInputProps }
    },
    {
      Input: DropdownComponent,
      Props: {
        ...inputProps.CurrencyNameHawala, 
        // onChange: handleInputChange,
        // onBlur: handleInputBlur,
        setInputProps },
      },
    {
      Input: TextComponent,
      Props: {
        ...inputProps.AccountTitleHawalaDr, 
        onCreated:handleInputCreated,
        // onChange: handleInputChange,
        // onBlur: handleInputBlur,
        setInputProps },
      },
    {
      Input: TextComponent,
      Props: {
        ...inputProps.AccountTitleHawalaCr, 
        onCreated:handleInputCreated,
        // onChange: handleInputChange,
        // onBlur: handleInputBlur,
        setInputProps },
      },
    {
      Input: HiddenComponent,
      Props: {
        ...inputProps.AccountIDHawalaDr, 
        onCreated:handleInputCreated,
        // onChange: handleInputChange,
        // onBlur: handleInputBlur,
        setInputProps },
      },
    {
      Input: HiddenComponent,
      Props: {
        ...inputProps.AccountIDHawalaCr, 
        onCreated:handleInputCreated,
        // onChange: handleInputChange,
        // onBlur: handleInputBlur,
        setInputProps },
      },
    {
      Input: ()=>{

        return(
          <div className='SaleInvoiceEvaluation-footer-parent'>
          <ButtonInput onClose={onClose} onSave={onSave}/>
          </div>
        )
      },
      Props: {
       name:'popup-footer-parent' , 
        onCreated:handleInputCreated,
        // onChange: handleInputChange,
        // onBlur: handleInputBlur,
        setInputProps },ColumnSize:12
      },
  ];
//   const FirstGridComponent = useMemo(()=>()=>{
//  return( <StructuredGenerate   mainProps={props} title={'Invoice Evaluation Add'} Inputs={inputsList}/>)
//   },[inputProps])



  return (
    <>
      {/* <FirstGridComponent/> */}
      <StructuredGenerate   mainProps={{...props,isAdd:true}} title={`Invoice Evaluation  - ${inputProps.isAdd.value == true ? `Add` : `Edit`}`} Inputs={inputsList}/>
     {/* <pre>{JSON.stringify(inputProps, null, 2)}</pre> This is to display current state for debugging  */}
    </>
  );
}; 

export default InvoiceEvaluationAdd;
